export const WORLD_SIZE = 1024;
export const CHUNK_SIZE = 64;
export const CHUNK_COUNT = WORLD_SIZE / CHUNK_SIZE;
export const MIN_Y = -40;
export const MAX_HEIGHT = 420;
export const SKIRT = 32;
export const MAX_QUADS = 22000;

export const LOD_SCALES = [1, 2, 4, 8];
